// extracted by css-extract-rspack-plugin
module.exports =  {"primaryPanelHeader":"Widow__primaryPanelHeader--l1yCZ"};